var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserPlaceholder = function SvgUserPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DDD",
    d: "M19 .667C8.88.667.667 8.88.667 19S8.88 37.333 19 37.333 37.333 29.12 37.333 19 29.12.667 19 .667m0 5.5c3.043 0 5.5 2.456 5.5 5.5s-2.457 5.5-5.5 5.5a5.493 5.493 0 0 1-5.5-5.5c0-3.044 2.457-5.5 5.5-5.5M19 32.2a13.2 13.2 0 0 1-11-5.903c.055-3.649 7.333-5.647 11-5.647 3.648 0 10.945 1.998 11 5.647A13.2 13.2 0 0 1 19 32.2",
    opacity: 0.3
  })));
};
export default SvgUserPlaceholder;